module.exports = {"id":"202857","name":"Karim Bellarabi","rating":"81","photo":"./data/images/photos/1/202857.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KarimBellarabi0.json
// module id = 2288
// module chunks = 0